module.exports = __webpack_public_path__ + "static/media/brand-image.801af239.svg";